﻿import Swiper, { Navigation } from 'swiper';

import { debounce } from '../functions';

Swiper.use([Navigation]);

const mobileSwiperSelector = '.swiper--mobile';
const alwaysSwiperSelector = '.swiper--always';
const wideSwiperClass = 'swiper--wide';

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperNavCountSelector = '.swiper-count';

let swiperArray = [];

const swiperConfig = {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    breakpoints: {
        768: {
            slidesPerView: 2.2,
            slidesPerGroup: 2,
        },
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
    },
    navigation: {
        nextEl: swiperNavNextSelector,
        prevEl: swiperNavPrevSelector,
    },
    on: {
        init: (swiper) => {
            setSwiperCount(swiper);
        },
        slideChange: (swiper) => {
            setSwiperCount(swiper);
        },
        resize: (swiper) => {
            setSwiperCount(swiper);
        }
    },
};

const setSwiperCount = (swiper) => {
    const $countEl = swiper.el.querySelector(swiperNavCountSelector);
    let factor = 1;
    switch (parseInt(swiper.currentBreakpoint)) {
        case 768:
            factor = 2;
            break;
        case 1024:
            factor = 3;
            break;
        case 1408:
            factor = swiper.el.classList.contains(wideSwiperClass) ? 4 : 3;
            break;
        default:
            factor = 1;
            break;
    }
    let index = Math.ceil((swiper.realIndex + 1) / factor);
    if (swiper.isEnd) index = Math.ceil(swiper.slides.length / factor);
    let slidesLength = Math.ceil(swiper.slides.length / factor);
    $countEl.innerHTML = slidesLength === 1 ? '' : `${index}/${slidesLength}`;

    let id = swiper.el.id;

    if (slidesLength === 1 && swiperArray[id]) {
        swiperArray[id].destroy();
        delete swiperArray[id];
    }
};

const initMobileSwipers = () => {
    const $mobileSwipers = document.querySelectorAll(mobileSwiperSelector);

    $mobileSwipers.forEach(($mobileSwiper) => {
        initMobileSwiper($mobileSwiper, $mobileSwiper.id);
    });
};

const initMobileSwiper = ($swiperEl, id) => {
    if (!swiperArray[id] && window.innerWidth <= 1023) {
        swiperArray[id] = new Swiper($swiperEl, {
            ...swiperConfig
        });
    } else if (swiperArray[id] && window.innerWidth > 1023) {
        swiperArray[id].destroy();
        delete swiperArray[id];
    }
};

const initAlwaysSwipers = () => {
    const $alwaysSwipers = document.querySelectorAll(alwaysSwiperSelector);

    $alwaysSwipers.forEach(($alwaysSwiper) => {
        let swiper = new Swiper($alwaysSwiper, {
            ...swiperConfig,
            spaceBetween: 24,
        });
    });
};

document.addEventListener('DOMContentLoaded', () => {
    initMobileSwipers();
    initAlwaysSwipers();
});

window.addEventListener('resize', await debounce(initMobileSwipers));

export { swiperConfig };
